import React from 'react';
import './PainPoint.css';

const PainPoint = ({title, notes}) => {
  return (
    <div className='painPoint'>
      <div className='ppTitle'>{title}</div>
      <div className='ppNotes'>{notes}</div>
    </div>
  );
};

export default PainPoint;